import vacancies from './vacancies'
import stories from './stories'

export default {
  job: {
    namespaced: true,
    modules: {
      vacancies,
      stories
    }
  }
}
